import React from "react";
import AboutCard from "../Components/AboutCard/AboutCard";
import Hero from "../Components/Hero/Hero";
const About = () => {
  return (
    <div className="home_page">
      <Hero />
      <AboutCard />
    </div>
  );
};

export default About;
